"use strict";

const BaseXform = require('../base-xform');
class BooleanXform extends BaseXform {
  constructor(options) {
    super();
    this.tag = options.tag;
    this.attr = options.attr;
  }
  render(xmlStream, model) {
    if (model) {
      xmlStream.openNode(this.tag);
      xmlStream.closeNode();
    }
  }
  parseOpen(node) {
    if (node.name === this.tag) {
      this.model = true;
    }
  }
  parseText() {}
  parseClose() {
    return false;
  }
}
module.exports = BooleanXform;
//# sourceMappingURL=boolean-xform.js.map
